// extracted by mini-css-extract-plugin
export default {"headerTitle":"popularProduct_headerTitle__QJ-e9","page":"popularProduct_page__zGeEo","header":"popularProduct_header__yMFhr","container":"popularProduct_container__UQASW"};